import React, { Component } from 'react';
import {
    Container,
    Table,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from 'reactstrap';

/**
 * Used for the Listino Prezzi section. 
 */
export class Catalogo3 extends Component {

    constructor(props) {
        super(props);

        this.toggleDis = this.toggleDis.bind(this);
        this.toggleLiv1 = this.toggleLiv1.bind(this);
        this.toggleLiv2 = this.toggleLiv2.bind(this);
        this.toggleLiv3 = this.toggleLiv3.bind(this);
        this.toggleApriModal = this.toggleApriModal.bind(this);
        this.state = {
            
            apertaDis: false,
            apertaLiv1: false,
            apertaLiv2: false,
            apertaLiv3: false,
            modalAperta: false,
            articoloMod: {},
            liv1: [],
            liv2: [],
            liv3: [],
            livDisp: [],
            liv1Id: 0,
            liv2Id: 0,
            liv3Id:0,
            liv1Desc: "",
            liv2Desc: "",
            liv3Desc: "",
            disp: false,
            art: "",
            desc: "",
            livMod: 0,
            livMod2: 0,
            livMod3: 0,
          
        };

        fetch('/api/CatLivelli1', {
            method: 'GET',
            headers: new Headers({
                Authorization: 'Bearer ' + sessionStorage.getItem("auth")
            })
        }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    liv1: myjson
                })
            })
            .catch(error => {
                console.log(error);
            });

        fetch('/api/drop2', {
            method: 'GET',
            headers: new Headers({
                Authorization: 'Bearer ' + sessionStorage.getItem("auth")
            })
        }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    liv2: myjson
                })
            })
            .catch(error => {
                console.log(error);
            });

        fetch('/api/drop3', {
            method: 'GET',
            headers: new Headers({
                Authorization: 'Bearer ' + sessionStorage.getItem("auth")
            })
        }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    liv3: myjson
                })
            })
            .catch(error => {
                console.log(error);
            });

        fetch('/api/disponibile', {
            method: 'GET',
            headers: new Headers({
                Authorization: 'Bearer ' + sessionStorage.getItem("auth")
            })
        }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    livDisp: myjson
                })
            })
            .catch(error => {
                console.log(error);
            });

        

        
       
    }
    toggleDis() {
        this.setState({
            apertaDis: !this.state.apertaDis,
        });
    }
    toggleLiv1() {
        this.setState({
            apertaLiv1: !this.state.apertaLiv1,
        });
    }
    toggleLiv2() {
        this.setState({
            apertaLiv2: !this.state.apertaLiv2,
        });
    }
    toggleLiv3() {
        this.setState({
            apertaLiv3: !this.state.apertaLiv3,
        });
    }

    toggleApriModal = (livello) => {
        let articoloid = livello.articoloId;
        let descrizione = livello.descrizione;
        let desc1 = livello.livello1;
        let desc2 = livello.livello2;
        let desc3 = livello.livello3;
        let dis = livello.disponibile;
        let id1 = livello.livello1Id;
        let id2 = livello.livello2Id;
        let id3 = livello.livello3Id;
        this.setState({
           modalAperta: !this.state.modalAperta,
           liv1Desc: desc1,
           liv2Desc: desc2,
           liv3Desc: desc3,
           liv1Id: id1,
           liv2Id: id2,
           liv3Id: id3,
           disp: dis,
           art: articoloid,
           desc: descrizione,
        });
    }

    selezioneLiv1 = (valore) => {
        let temp = valore.deslv1;
        let temp1 = valore.livelli1Id;
        this.setState({
            liv1Desc: temp,
            liv1Id: temp1,
        });
        
    }

    selezioneLiv2 = (valore) => {
        let temp = valore.deslv2;
        let temp1 = valore.livelli2Id;
        this.setState({
            liv2Desc: temp,
            liv2Id: temp1,
        });

    }

    selezioneLiv3 = (valore) => {
        let temp = valore.deslv3;
        let temp1 = valore.livelli3Id;
        this.setState({
            liv3Desc: temp,
            liv3Id: temp1,
            
        });

    }

    selezioneLivDisp = (valore) => {
        let temp = valore
        this.setState({
            disp: temp,
        });

    }

    modifica = () => {

        const form = {
            articolo: this.state.art, 
            disponibile: this.state.disp,
            livello1: this.state.liv1Id,
            livello2: this.state.liv2Id,
            livello3: this.state.liv3Id,
        };

        fetch(`/api/modifica`, {
            method: 'POST',
            headers: new Headers({
               
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                'Content-Type': 'application/json'
            }),
           
            body: JSON.stringify(form)
           
        }).then(response => {
            this.setState({
                modalAperta: !this.state.modalAperta,
            });
           
        });
    }



    

    

       



   



    /**
     * Renders the page
     */
    render() {
        const livelli4Table = (
            <Table responsive>
                <thead>
                    <tr>
                        <th>Codice</th>
                        <th>Descrizione</th>
                        <th>U.M.</th>
                        <th>Peso Medio</th>
                        <th>Prezzo</th>
                        <th>Cartonaggio</th>
                        <th>Disponibilità</th>
                        <th>Livello 1</th>
                        <th>Livello 2</th>
                        <th>Livello 3</th>

                    </tr>
                </thead>
                <tbody>
                    {this.props.livelli4.map(element => {
                        //console.log(element)
                        return (
                            <tr key={element.articoloId}>
                                <td><a onClick={() => this.toggleApriModal(element)} style={{ color: "blue", cursor: "pointer" }}>{element.articoloId}</a></td>
                                <td>{element.descrizione}</td>
                                <td>{element.um}</td>
                                <td>{element.pesoMedio}</td>
                                <td>€ {parseFloat(element.listino).toFixed(2)}</td>
                                <td>{element.cartonaggio}</td>
                                <td>{element.disponibile == true ? "Disponibile" : "Non Disponibile"}</td>
                                <td>{element.livello1}</td>
                                <td>{element.livello2}</td>
                                <td>{element.livello3}</td>
                            </tr>
                        )
                    })
                    }  
                </tbody>
            </Table>
        );


        return (
            <Container fluid>
                {this.props.showLivelli4 ? livelli4Table : null}
                <container fluid>
                <Modal size="xl" isOpen={this.state.modalAperta} toggle={this.toggleApriModal} style={{ color: "#011e41" }}>
                    <ModalBody>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Codice</th>
                                    <th>Descrizione</th>
                                    <th>Disponibilità</th>
                                    <th>Livello 1</th>
                                    <th>Livello 2</th>
                                    <th>Livello 3</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{this.state.art}</td>
                                    <td>{this.state.desc}</td>
                                    <td>{this.state.disp == true ? "Disponibile" : "Non Dsponibile"}</td>
                                    <td>{this.state.liv1Desc}</td>
                                    <td>{this.state.liv2Desc}</td>
                                    <td>{this.state.liv3Desc}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <Dropdown isOpen={this.state.apertaDis} toggle={this.toggleDis}>
                                            <DropdownToggle caret>Disponibilità</DropdownToggle>
                                                <DropdownMenu modifiers={{
                                                    setMaxHeight: {
                                                        enabled: true,
                                                        order: 890,
                                                        fn: (data) => {
                                                            return {
                                                                ...data,
                                                                styles: {
                                                                    ...data.styles,
                                                                    overflow: 'auto',
                                                                    maxHeight: '200px',
                                                                },
                                                            };
                                                        },
                                                    },
                                                }}>
                                                               
                                                   
                                                        <DropdownItem
                                                             onClick={() => this.selezioneLivDisp(true)}>Disponibile</DropdownItem>

                                                        <DropdownItem
                                                            onClick={() => this.selezioneLivDisp(false)}>Non Disponibile</DropdownItem>
                                        
                                                    </DropdownMenu>
                                        </Dropdown>
                                    </td>
                                        <td> <Dropdown isOpen={this.state.apertaLiv1} toggle={this.toggleLiv1} navbar="true">
                                            <DropdownToggle caret>Livello 1</DropdownToggle>                                            
                                            <DropdownMenu modifiers={{
                                                setMaxHeight: {
                                                    enabled: true,
                                                    order: 890,
                                                    fn: (data) => {
                                                        return {
                                                            ...data,
                                                            styles: {
                                                                ...data.styles,
                                                                overflow: 'auto',
                                                                maxHeight: '200px',
                                                            },
                                                        };
                                                    },
                                                },
                                            }}> 
                                                               {
                                                this.state.liv1.map(value =>
                                                    <DropdownItem
                                                        key={value} onClick={() => this.selezioneLiv1(value)}>
                                                                        {value.deslv1}
                                                                        </DropdownItem>)
                                                                }  
                                                </DropdownMenu>
                                        </Dropdown>
                                    </td>
                                    <td> <Dropdown isOpen={this.state.apertaLiv2} toggle={this.toggleLiv2} navbar="true" >
                                                    <DropdownToggle caret>Livello 2</DropdownToggle>

                                            <DropdownMenu modifiers={{
                                                setMaxHeight: {
                                                    enabled: true,
                                                    order: 890,
                                                    fn: (data) => {
                                                        return {
                                                            ...data,
                                                            styles: {
                                                                ...data.styles,
                                                                overflow: 'auto',
                                                                maxHeight: '200px',
                                                            },
                                                        };
                                                    },
                                                },
                                            }}> {
                                            this.state.liv2.map(value =>
                                                <DropdownItem
                                                    key={value} onClick={() => this.selezioneLiv2(value)}>
                                                    {value.deslv2}
                                                </DropdownItem>)
                                                    }             
                                                    </DropdownMenu>
                                         </Dropdown>
                                   </td>
                                        <td><Dropdown isOpen={this.state.apertaLiv3} toggle={this.toggleLiv3}>
                                            <DropdownToggle caret>Livello 3</DropdownToggle>
                                            <DropdownMenu modifiers={{
                                                setMaxHeight: {
                                                    enabled: true,
                                                    order: 890,
                                                    fn: (data) => {
                                                        return {
                                                            ...data,
                                                            styles: {
                                                                ...data.styles,
                                                                overflow: 'auto',
                                                                maxHeight: '200px',
                                                            },
                                                        };
                                                    },
                                                },
                                            }}> {
                                                    this.state.liv3.map(value =>
                                                        <DropdownItem
                                                            key={value} onClick={() => this.selezioneLiv3(value)}>
                                                            {value.deslv3}
                                                        </DropdownItem>)
                                                }
                                            </DropdownMenu>
                                        </Dropdown>
                                    </td>
                                </tr>

                                
                            </tbody>
                        </Table>
                    </ModalBody>
                    <ModalFooter>
                            <Container className="d-flex justify-content-center align-items-center" fluid>
                                <Button className="text-center" style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.modifica()}>
                                Salva
                            </Button>
                            <Button className="text-center" style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.setState({ modalAperta: false })}>
                                Annulla
                            </Button>
                        </Container>
                    </ModalFooter>
                    </Modal>
                </container>
            </Container>
          )

    }

}




// WEBPACK FOOTER //
// ./src/components/Catalogo/Catalogo3.js